module.exports = __webpack_public_path__ + "28b67065/img/send-icon.3cfb6275.svg";